import { render, staticRenderFns } from "./HistoricalData.vue?vue&type=template&id=e281de4a&"
import script from "./HistoricalData.vue?vue&type=script&lang=js&"
export * from "./HistoricalData.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports